export const inputTextHorizontalPadding = '15px';
export const inputTextVerticalPadding = '13px';
export const inputLineHeight = '14px';

export const inputHeight = '48px';

export const inputInformationSpanHeight = '12px';

export const showPasswordButtonHeight = '18px';
